<template>
  <div
    :class="
      screen === 'mobile' ? '' : 'has-padding-right-55 has-padding-left-55'
    "
  >
    <business-list-page></business-list-page>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BusinessListPage from '@/components/Business/BusinessListPage'

export default {
  components: { BusinessListPage },
  head() {
    return {
      title: `Business | Rojgari`
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen', showChart: 'getChart' })
  }
}
</script>
